import { useQuery } from "@tanstack/react-query";
import { fetchGalleryImages } from "../../api/gallery.api";

export const useGalleryImages = () => {
  return useQuery({
    queryKey: ["adm-gallery-images"],
    queryFn: fetchGalleryImages,
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
  });
};